import React from 'react';
import dayjs from 'dayjs';
import Image from 'next/legacy/image';
import arrowLeft from '@assets/images/arrow-left-bold.svg';
import arrowRight from '@assets/images/arrow-right-bold.svg';
import SearchOption from '@customTypes/search-option';
import Dropdown from '@components/common/Dropdown/Dropdown';

type Props = {
  options: SearchOption[];
  onOptionSelect: (value: SearchOption, dateRange?: Date | undefined) => void;
  dropdownValue: SearchOption | undefined;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  onPreviousMonthClick: (increaseMonth: () => void, date: Date) => void;
  onNextMonthClick: (decreaseMonth: () => void, date: Date) => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  date: Date;
  onDropDownReset: () => void;
};

export default function DesktopCustomHeader({
  options,
  onOptionSelect,
  dropdownValue,
  onPreviousMonthClick,
  onNextMonthClick,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
  date,
  onDropDownReset,
}: Props) {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col pb-5 pl-7 -ml-2 mt-2 mb-6 border-b border-solid border-rp-gray-divider d:flex-row">
        <div className="h-auto w-full mb-3 text-left font-rp-pn-regular text-sm d:w-1/3 d:mb-0 d:font-semibold d:tracking-wide">
          Only show availability for:
        </div>
        <div className="w-2/3 -ml-2 pr-2 max-w-sm hidden d:block">
          <Dropdown
            isMultiSelect={false}
            options={options}
            onChange={onOptionSelect}
            value={dropdownValue}
            onReset={onDropDownReset}
            placeHolder="Select a product"
          />
        </div>
      </div>
      <div className="flex justify-between mx-2.5 text-17 mb-3 px-5">
        <button
          onClick={() => onPreviousMonthClick(decreaseMonth, date)}
          disabled={prevMonthButtonDisabled}
          type="button"
        >
          <div
            className={`h-3 w-3 relative mr-3 ${
              prevMonthButtonDisabled ? 'opacity-30' : 'opacity-100'
            }`}
          >
            <Image src={arrowLeft} layout="fill" alt="left-arrow" />
          </div>
        </button>
        {dayjs(date).format('MMMM YYYY')}
        <button
          onClick={() => onNextMonthClick(increaseMonth, date)}
          disabled={nextMonthButtonDisabled}
          type="button"
        >
          <div
            className={`h-3 w-3 relative mr-3 ${
              nextMonthButtonDisabled ? 'opacity-30' : 'opacity-100'
            }`}
          >
            <Image src={arrowRight} layout="fill" alt="right-arrow" />
          </div>
        </button>
      </div>
    </div>
  );
}
